/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface IAccountLoyaltyLabel {
    className?: string;
    text?: string | number;
}

export const AccountLoyaltyLabel: React.FC<IAccountLoyaltyLabel> = ({ className, text }) => (
    <p className={ className }>{ text }</p>
);

export interface IAccountLoyaltyModalLabel {
    className?: string;
    text?: string | number;
    labelFor?: string;
}

export const AccountLoyaltyModalLabel: React.FC<IAccountLoyaltyModalLabel> = ({ className, text, labelFor }) => (
    <label className={ className } htmlFor={ labelFor } >{ text } </label>
);
